import { styled } from '@mui/material/styles';

export const Container = styled('div')(() => ({
  overflow: 'hidden'
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  margin: theme.spacing(0, 0, 2, -1),
  '@media (max-width: 500px)': {
    flexDirection: 'column'
  }
}));

export const Subtitle = styled('div')(({ theme, underlined, pointer }) => ({
  margin: theme.spacing(0, 0, 2, 0),
  padding: theme.spacing(0, 0, 1.5, 0),
  ...(underlined && { borderBottom: `1px solid ${theme.color.grey[500]}` }),
  ...(pointer && { cursor: 'pointer' }),
  display: 'flex',
  justifyContent: 'space-between',
  marginRight: theme.spacing(5),
  flexWrap: 'wrap',
  flexDirection: 'row-reverse',
  '& h3': {
    fontSize: theme.fontSize.large,
    fontWeight: theme.fontWeight.normal,
    textAlign: 'left',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    margin: theme.spacing(0.6, 2, 0, 0)
  },
  '@media (max-width: 450px)': {
    marginRight: theme.spacing(2)
  }
}));
